export var SORT_ORDER_KEY = {
  ASC: 'ASC',
  DESC: 'DESC'
};
export var SORT_SEQUENCE = {
  ASC: 'asc',
  DESC: 'desc'
};
export var DEFAULT_SELECT_SORT_ORDER = [{
  order: SORT_ORDER_KEY.ASC,
  field: 'label'
}];
export var SORT_OVERRIDE_INDEX = 'sortOverrideIndex';
export default SORT_ORDER_KEY;